import React, { Component } from 'react';
import styles from './Suggestions.module.css';
import {connect} from 'react-redux';
import axios from 'axios';
import loader from '../../assets/loader.svg';
import loader2 from '../../assets/loader2.svg';
import noUser from '../../assets/no_user.jpg';
import checkedUserIcon from '../../assets/checked_user.png';
import {Link} from 'react-router-dom';
import Modal from '../../components/ConfirmModal/Modal';
import Search from './Search/Search';

class Suggestions extends Component {

    state = {
        users: {},
        followClicked: [],
        following: [],
        sentRequest: [],
        modal: {
            isModalOpen: false,
            userId: '',
            name: '',
            profilePic: '',
            clicked: false
        }
    }
    followQueue = [];
    requestQueue = [];

    componentDidMount() {
        if(localStorage.getItem('suggest_users')) {
            this.setState({ users: JSON.parse(localStorage.getItem('suggest_users'))});
        }
        axios.get('/users.json?auth='+ this.props.loginStatus.authToken)
        .then(response=>{
           this.setState({
               users: response.data,
               following: response.data[this.props.loginStatus.userId].following,
               sentRequest: response.data[this.props.loginStatus.userId].sentRequest
            });

            localStorage.setItem('suggest_users',JSON.stringify(response.data));
        })
        .catch(error=>console.log(error))


        // axios.get('/users.json?auth='+ this.props.loginStatus.authToken)
        // .then(response=>{
        //     const users = response.data;
        //    Object.keys(response.data).map(userId => {
        //      users[userId].account_status='Available';
             
        //    });
        // axios.put('/users.json?auth='+ this.props.loginStatus.authToken, users)
        // .then(res=>console.log(res))
        // })
        
    }

    followRequest = (userId) => {
        const loggedInUserId = this.props.loginStatus.userId;
        let isFirst = this.requestQueue.length === 0;
        if(this.requestQueue.indexOf(userId) === -1){
            this.requestQueue.push(userId);
    
        } else {
            isFirst = true;
        }
        if(!isFirst) return;
        axios.get('/users/' + userId + '.json?auth=' + 
        this.props.loginStatus.authToken)
         .then(response => {
             const userData = response.data;
             if(userData.requests.indexOf(loggedInUserId) !== -1) return;
             userData.requests.push(loggedInUserId);
             userData.notifications.map((obj, index) => {
                if(obj.userId === loggedInUserId && obj.key === 'REQUEST') {
                    userData.notifications.splice(index, 1);
                }
            })
            userData.notifications.push({
                key: 'REQUEST',
                name: this.props.userData.name,
                isRead: false,
                profilePic: this.props.userData.profilePic,
                timeStamp: new Date(),
                userId: loggedInUserId
            });
            axios.put('/users/' + userId + '.json?auth=' + 
            this.props.loginStatus.authToken, userData)
            .catch(err=>console.log(err));

            axios.get('/users/'+ loggedInUserId +'/sentRequest.json?auth='+ 
            this.props.loginStatus.authToken)
            .then(response2 => {
                const sentRequests = response2.data;
                sentRequests.push(userId);
                axios.put('/users/'+ loggedInUserId +'/sentRequest.json?auth='+ 
                this.props.loginStatus.authToken, sentRequests)
                .then((res) => {
                    this.requestQueue.shift();
                    this.setState((prevState) => {
                    const array = prevState.followClicked;
                    array.splice(array.indexOf(loggedInUserId), 1);
                    
                    return {
                        followClicked: array,
                        sentRequest: res.data
                    }
                });
               if(this.requestQueue.length > 0) this.follow(this.requestQueue[0]);
              
           })
           .catch(error=>console.log(error));
       })
         })
         .catch(err=>console.log(err));
    }

    cancelRequest = (userId) => {
        const loggedInUserId = this.props.loginStatus.userId;
        axios.get('/users/' + userId + '.json?auth=' + 
        this.props.loginStatus.authToken)
         .then(response => {
             const userData = response.data;
             userData.requests.splice(userData.requests.indexOf(loggedInUserId), 1);
             userData.notifications.map((obj, index) => {
                 if(obj.userId === loggedInUserId && obj.key === 'REQUEST') {
                     userData.notifications.splice(index, 1);
                 }
             })
            axios.put('/users/' + userId + '.json?auth=' + 
            this.props.loginStatus.authToken, userData)
            .catch(err=>console.log(err));

            axios.get('/users/'+ loggedInUserId +'/sentRequest.json?auth='+ 
            this.props.loginStatus.authToken)
            .then(response2 => {
                const sentRequests = response2.data;
                sentRequests.splice(sentRequests.indexOf(userId), 1);
                axios.put('/users/'+ loggedInUserId +'/sentRequest.json?auth='+ 
                this.props.loginStatus.authToken, sentRequests)
                .then((res) => {
                    this.setState( {
                        sentRequest: res.data
                    })              
           })
           .catch(error=>console.log(error));
       })
            
         })
         .catch(err=>console.log(err));
    }

    follow = (userId) => {
       const loggedInUserId = this.props.loginStatus.userId;
       this.setState((prevState) => {
          if(prevState.followClicked.indexOf(userId) >= 0) return;
          return {followClicked: [...prevState.followClicked, userId]};
       });
     
        let isFirst = this.followQueue.length === 0;
        if(this.followQueue.indexOf(userId) === -1){
            this.followQueue.push(userId);
    
        } else {
            isFirst = true;
        }
        if(!isFirst) return;

       axios.get('/users/' + userId + '.json?auth=' + 
       this.props.loginStatus.authToken)
        .then(response => {
            const userData = response.data;
            if(userData.isAccountPrivate) {
                this.followQueue.splice(this.followQueue.indexOf(userId), 1);
                this.followRequest(userId);
                return;
            }
            if(userData.followers.indexOf(loggedInUserId) !== -1) return;
            userData.followers.push(loggedInUserId);
           
            userData.notifications.map((obj, index) => {
                   if(obj.userId === loggedInUserId && obj.key === 'FOLLOW') {
                       userData.notifications.splice(index, 1);
                   }
            })
            userData.notifications.push({
                key: 'FOLLOW',
                name: this.props.userData.name,
                isRead: false,
                profilePic: this.props.userData.profilePic,
                timeStamp: new Date(),
                userId: loggedInUserId
            })
           // userData.notifications = userData.notifications.slice(-10);
            axios.put('/users/'+ userId +'.json?auth='+ 
            this.props.loginStatus.authToken, userData)
            .catch(error=>console.log(error));

            axios.get('/users/'+ loggedInUserId +'/following.json?auth='+ 
            this.props.loginStatus.authToken)
            .then(response2 => {
                const loggedInUserFollowing = response2.data;
                loggedInUserFollowing.push(userId);
                axios.put('/users/'+ loggedInUserId +'/following.json?auth='+ 
                this.props.loginStatus.authToken, loggedInUserFollowing)
                .then((res) => {
                    this.followQueue.shift();
                    this.setState((prevState) => {
                    const array = prevState.followClicked;
                    array.splice(array.indexOf(loggedInUserId), 1);
                    
                    return {
                        following: res.data,
                        followClicked: array
                    }
                });
               if(this.followQueue.length > 0) this.follow(this.followQueue[0]);
              
           })
           .catch(error=>console.log(error));
       })

        })
      
       
    }

    unfollow = () => {
        this.setState({
            modal: {
                ...this.state.modal,
                clicked: true
            }
        });
        const userId = this.state.modal.userId;
        const loggedInUserId = this.props.loginStatus.userId;
    
       axios.get('/users/'+ userId +'/followers.json?auth='+ 
       this.props.loginStatus.authToken)
        .then(response=>{
            const userFollowers = response.data;
            if(userFollowers.indexOf(loggedInUserId) === -1) return;
            userFollowers.splice(userFollowers.indexOf(loggedInUserId), 1);
            axios.put('/users/'+ userId +'/followers.json?auth='+ 
            this.props.loginStatus.authToken, userFollowers)
            .catch(error=>console.log(error));

            axios.get('/users/'+ loggedInUserId +'/following.json?auth='+ 
            this.props.loginStatus.authToken)
            .then(response2 => {
                const loggedInUserFollowing = response2.data;
                if(loggedInUserFollowing.indexOf(userId) === -1) return;
                loggedInUserFollowing.splice(loggedInUserFollowing.indexOf(userId), 1);
                axios.put('/users/'+ loggedInUserId +'/following.json?auth='+ 
                this.props.loginStatus.authToken, loggedInUserFollowing)
                .then((res) => {
                    this.toggleModal();
                    this.setState({
                        following: res.data,
                        modal: {
                            ...this.state.modal,
                            clicked: false
                        }
                    });
                    
                })
            })
            .catch(error=>console.log(error));

        })
    }

    toggleModal = () => {
        this.setState({
            modal: {
                isModalOpen: false,
                userId: '',
                name: '',
                profilePic: ''
            }
        });
    }

    followingClickHandler = (userId, name, profilePic) => {
        this.setState({
            modal: {
                isModalOpen: true,
                userId: userId,
                name: name,
                profilePic: profilePic
            }
        })
    }
    getButton = (userId, user) => {
        let button = null;
        if(this.state.following.indexOf(userId) === -1) {
            if(this.state.sentRequest.indexOf(userId) === -1) {
                button =  (<button className={styles.follow} onClick={()=>this.follow(userId)}>
                        {this.state.followClicked.indexOf(userId) === -1 ?
                            'Follow' :
                            <img src={loader2} alt="loader" width="18" height="18" style={{marginTop: '5px'}} />
                        } 
                        </button>
                        )
            } else {
              button = <button className={styles.request} onClick={()=>this.cancelRequest(userId)}>Requested</button>
            }
        } else {
          button =  (<button className={styles.following} 
                    onClick={()=>this.followingClickHandler(userId, user.name, user.profilePic)}>
                        <img src={checkedUserIcon} alt="following icon" width="20" height="20" />
                    </button> 
                    )
        }

        return button;
    }
    
    render() {
       
        return (
            <div className={styles.feed}>
                <section>
                <div className={styles.top}>
                    <h4>Suggestions For You</h4>
                    {this.props.search?
                    <Search users={this.state.users} userId={this.props.loginStatus.userId} />
                    :null
                    }
                   <div className={styles.suggestions}>
                       
                       {
                        Object.keys(this.state.users).map(userId => {
                            let user = this.state.users[userId];
                            if(userId === this.props.loginStatus.userId || user.account_status === 'DISABLED') return null;
                        return(  
                            <div className={styles.user} key={userId}>
                                <div className={styles.dp}>
                                 <Link to={'/account/' + userId} >
                                  <img src={user.profilePic ? user.profilePic : noUser} 
                                   width="50" height="50" alt={user.name + '\'s profile pic'} /> 
                                  <div className={styles.cover}></div>
                                  </Link>
                                </div>
                                <div className={styles.details}>
                                <Link to={'/account/' + userId} >
                                 <div className={styles.name}>
                                    <h2>{user.name}</h2> 
                                    {user.isVerified ?
                                    <span style={{marginLeft:'5px'}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="16px" height="16px">
                                    <polygon fill="#42a5f5" points="29.62,3 33.053,8.308 39.367,8.624 39.686,14.937 44.997,
                                    18.367 42.116,23.995 45,29.62 39.692,33.053 39.376,39.367 33.063,39.686 29.633,44.997 24.005,
                                    42.116 18.38,45 14.947,39.692 8.633,39.376 8.314,33.063 3.003,29.633 5.884,24.005 3,18.38 8.308,
                                    14.947 8.624,8.633 14.937,8.314 18.367,3.003 23.995,5.884"/>
                                    <polygon fill="#fff" points="21.396,31.255 14.899,24.76 17.021,22.639 21.428,27.046 30.996,
                                    17.772 33.084,19.926"/>
                                    </svg>
                                    </span>
                                    : null
                                    }
                                    
                                </div>
                                </Link>
                                <div className={styles.recommend}>FakeInsta recommended</div>
                                </div>
                                <div  style={{padding:'5px'}}>
                                   {this.getButton(userId, user)}
                                </div>
                            </div>
                            )
                        })
                       }

                       {
                           Object.keys(this.state.users).length === 0 ?
                           <div style={{marginTop:'35%'}}>
                                <img src={loader} alt="loading"/>
                           </div>
                           :null
                       }

                   </div>  
                </div>
                </section>
                {this.state.modal.isModalOpen ?
                <Modal message={`Unfollow ${this.state.modal.name} ?`} imageUrl={this.state.modal.profilePic} 
                closeModal={this.toggleModal} action="Unfollow" confirm={this.unfollow} clicked={this.state.modal.clicked}/>
                : null
                }
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus,
        userData: state.userData
    }
}

export default connect(mapStateToProps)(Suggestions);